<template lang="pug">
.inside-padding
  form(@submit.prevent="")
    h3.capitalize Crear Factura de Devolución

    .input-container
      input.input(v-model="order" required)
      label.label(:class="{ show: order }") Orden

    .input-container.arrow
      select.select(v-model="conveyor" autocomplete="ño" required)
        option(value="")
        option(value="envia") Envia
      label.label(:class="{ show: conveyor }") Transpotadora

    .input-container
      input.input(v-model="tracking" required)
      label.label(:class="{ show: traking }") Guía

    .input-container
      input.input(v-model.number="value" type="number" min="1000" required)
      label.label(:class="{ show: value }") Value

    .description-invoice(v-if="tracking")
      span.dark Descripción:
      span  {{ description(tracking) }}

    shActionButton(:isForm="true" :action="createInvoice" text="Crear Factura" textRunning="Creando Factura")
</template>

<script>
import gql from '@my/graphql'
import gqlInvoice from '@/graphql/invoice'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import shInputList from '@/components/elements/InputList'

export default {
  name: 'ConveyorInvoice',

  mixins: [mForm],

  components: { shInputList },

  data () {
    return {
      order: '',
      conveyor: '',
      tracking: '',
      value: '',
      description: (tracking) => `Envío perdido con número de guía ${tracking}`
    }
  },

  methods: {
    async createInvoice () {
      const mutation = gqlInvoice.CREATE_CONVEYOR
      const response = await gql.mutate(mutation, { conveyor: this.conveyor, value: this.value, description: this.description(this.tracking), order: this.order })

      if (response && response.data && response.data.createInvoiceConveyor) {
        modals.showMessage({ message: `Se creó una nueva factura` })
        this.order = ''
        this.conveyor = ''
        this.value = ''
        this.tracking = ''
      }
    }
  }
}
</script>

<style lang="stylus">
.inside-padding
  padding-bottom 2em

.description-invoice
  font-size 1.2em
  margin 0 1em 1em 1em
  text-align left
</style>



// WEBPACK FOOTER //
// src/components/pages/invoice/conveyorInvoice.vue